<template>
    <div id="score_box">
        <div>
            <span id="score">{{ score }}</span>
        </div>
        <!-- <div>
            （<span>{{ ranking.max }}</span>人中<span id="rank">{{ ranking.rank }}</span>位）
        </div> -->
    </div>
</template>

<script>
export default {
name: "ScoreBoard",
props:{
    'score': [String, Number],
    'ranking': {
        'max': Number,
        'rank': Number
    }
}
};

</script>

<style scoped>
#score_box{
    margin-top: 2%;
    margin-bottom: 5%;
}
#score{
    color: purple;
    font-size: 55px;
}
#rank{
    color: #42b983;    
}
</style>